module.exports = __webpack_public_path__ + "static/img/piliangshanchu2.04cacfa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/piliangshanchu2.png
// module id = MhE2
// module chunks = 24